import type { EduCourseTariff } from '@common/types/edu-course.type';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

const EduCoursesTariffsActions = createActionGroup({
    source: 'EduCoursesTariffs/CollectionQuery/API',
    events: {
        'Load Collection Request': emptyProps(),
        'Load Collection Success': props<{ tariffs: EduCourseTariff[] }>(),
        'Load Collection Failure': props<{ error: string }>(),
    },
});

export default EduCoursesTariffsActions;
